import Context from './Context';

export default class Topic {

  static publish(topicName: string, data: any) {
    try {
      const topic: any = Context.instance.lib.dojo.topic;
      topic.publish(topicName,data);
    } catch(ex) {
      console.warn("Error publishing topic",topicName);
      console.error(ex);
    }
  }

  static subscribe(topicName: string, callback: any) {
    const topic: any = Context.instance.lib.dojo.topic;
    return topic.subscribe(topicName,callback);
  }

  /* ======================================================================= */

  static Test1 = "g/Test1";

  static Test2 = "g/Test2";

  static PolicyActions_DestroyPalette = "g/PolicyActions_DestroyPalette";

  static PolicyActions_DestroyUpdate = "g/PolicyActions_DestroyUpdate";

  static PolicyActions_ShowModalSelect = "g/PolicyActions_ShowModalSelect";

  static PolicyActions_ShowPalette = "g/PolicyActions_ShowPalette";

  static PolicyActions_ShowUpdate = "g/PolicyActions_ShowUpdate";
  
  static WroModeler_Destroy = "g/WroModeler_Destroy";

  static WroModeler_Show = "g/WroModeler_Show";

  static WroModeler_ShowSave = "g/WroModeler_ShowSave";
  
}